export default __webpack_public_path__ + "static/media/pond.66a81230.jpg";